import { render, staticRenderFns } from "./OfferlogAdv.vue?vue&type=template&id=68215bd2&scoped=true&"
import script from "./OfferlogAdv.vue?vue&type=script&lang=js&"
export * from "./OfferlogAdv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68215bd2",
  null
  
)

export default component.exports